


// import React, { useState, useEffect } from 'react';
// import { Link, useLocation } from 'react-router-dom'; // Import useLocation

// import 'owl.carousel/dist/assets/owl.carousel.css'; // Import Owl Carousel styles
// import 'owl.carousel'; // Import Owl Carousel functionality
// import emailjs from 'emailjs-com'; // Import EmailJS
// // import logo from '../img/logo/IIA_LOGO_White_v3.png';
// // import logo1 from '../img/logo/IIA_LOGO_White_v3.png';
// import { useNavigate } from "react-router-dom";
// import logo from '../img/logo/HeadAllLogoIIALogo.png';
// import { FaShoppingCart } from 'react-icons/fa';
// const Nav = () => {
//   const [navbarBackground, setNavbarBackground] = useState(false);
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false); // For toggle
//   const location = useLocation(); // Get current location
//   const [searchQuery, setSearchQuery] = useState(""); // State for search input
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [showDropdown, setShowDropdown] = useState(false);

//   // const handleLogin = () => {
//   //   // After logging in, set isLoggedIn to true (you can replace this with actual login logic)
//   //   setIsLoggedIn(true);
//   // };


//   const toggleDropdown = () => {
//     setShowDropdown(!showDropdown); // Toggle the dropdown visibility
//   };

//   const handleLogout = () => {
//     localStorage.removeItem('userId');
//     navigate("/logindashboard");
//     // Log out logic and set isLoggedIn to false
//     setIsLoggedIn(false);
//   };


//   useEffect(() => {
//     const interval = setInterval(() => {
//       const userId = localStorage.getItem('userId'); // Retrieve userId from localStorage
//       if (userId) {
//         setIsLoggedIn(true); // If userId is found, mark as logged in
//       } else {
//         setIsLoggedIn(false); // If no userId, mark as logged out
//       }
//     }, 100); // Call every 1 second

//     // Cleanup the interval when the component unmounts
//     return () => clearInterval(interval);
//   }, []);

//   useEffect(() => {
//     const handleScroll = () => {
//       if (window.scrollY > 80) {
//         setNavbarBackground(true);
//       } else {
//         setNavbarBackground(false);
//       }
//     };

//     window.addEventListener('scroll', handleScroll);

//     return () => {
//       window.removeEventListener('scroll', handleScroll);
//     };
//   }, []);
//   // Update search query and filter suggestions
//   // Update search query and filter suggestions

//   const [filteredSuggestions, setFilteredSuggestions] = useState([]); // Filtered suggestions

//   const navigate = useNavigate(); // Navigation hook

//   const pages = [
//     { label: "Tool and Fixture Design", path: "/it-services" },
//     { label: "Virtual Robotics", path: "/web-mobile-applications" },
//     { label: "Digital Facility Solutions", path: "/gaming" },

//   ];

//   // Handle input change and filter suggestions 
//   const handleInputChange = (e) => {
//     // const query = e.target.value;
//     // setSearchQuery(query);

//     // if (query.trim() === "") {
//     //   setFilteredSuggestions([]);
//     // } else {
//     //   const lowerQuery = query.toLowerCase();
//     //   setFilteredSuggestions(
//     //     pages.filter((page) => page.label.toLowerCase().includes(lowerQuery))
//     //   );
//     // }
//   };

//   // Handle search button click
//   const handleSearch = () => {
//     if (searchQuery.trim() === "") return;

//     const lowerQuery = searchQuery.toLowerCase();
//     const matchedPage = pages.find(
//       (page) => page.label.toLowerCase() === lowerQuery
//     );

//     if (matchedPage) {
//       navigate(matchedPage.path); // Navigate to matched page
//     } else {
//       navigate("/not-found"); // Navigate to "Not Found" page
//     }
//   };

//   // Handle suggestion click
//   const handleSuggestionClick = (suggestion) => {
//     setSearchQuery(suggestion.label); // Update input value
//     navigate(suggestion.path); // Navigate to selected page
//     setFilteredSuggestions([]); // Clear suggestions
//   };
//   const toggleSidebar = () => {
//     setIsSidebarOpen(!isSidebarOpen); // Toggle sidebar state
//   };

//   return (
//     <>
//       {/* Navbar Header */}
//       <header className="init">
//         <div className={`navbar-default-white navbar-fixed-top  : 'orange'}`}>
//           <div className="container-fluid">
//             <div className="row p-3-vh align-items-center" style={{backgroundColor:"blue"}}>
//               {/* Logo and Text */}
//               <Link className="logo centered d-flex align-items-center" to="/">
//                 <div className="logo d-flex align-items-center">
//                   <img alt="logo" src={logo} style={{ maxHeight: '103px', paddingBottom: '1px' }} className='logo-change' />
//                   <span style={{ padding: '35px', }}>
//                     <p style={{ fontSize: '20px', minWidth: '0px', color: '#fff', fontWeight: '800',fontFamily:"Montserrat", }} className='titlenamel'>  INTERNATIONAL INSTITUTE<br></br> OF AUTOMATE</p>
//                     {/* <p style={{ fontSize: '13px' }}>(Powered by Envision Intigrated Services)</p> */}
//                   </span>

//                 </div>
//                 {/* <img className="h-150 show" alt="logo" src={logo1} /> */}
//                 {/* <div className="ml-3 text-white">
//                   <Link to="/" className="text-white text-decoration-none">
//                     <h1 className="m-0 fontsmall" style={{ fontFamily: 'Raqupine Regular' }}>MODULEX</h1>
//                     <p className="m-0 fontmini" >INTERIORS</p>
//                   </Link>
//                 </div> */}
//               </Link>
//               {/* Main Menu */}
//               <div
//                 className="menu-container mdflbg"
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-between", // Space out sections evenly
//                   // alignItems: "center", // Vertically align items
//                   // padding: "24px", // Add padding for spacing
//                   flexWrap: "wrap", // Allow items to wrap for smaller screens
//                 }}
//               >
//                 {/* Search Bar */}
//                 <div>
//                   {/* Search Bar */}
//                   <div
//                     className="firstsearch"
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       border: "1px solid #ddd",
//                       borderRadius: "30px",
//                       padding: "5px 10px",
//                       position: "relative",
//                       backgroundColor: "white",
//                       maxWidth: "100%",
//                       // width: "100%",
//                       width: '450px',
//                        marginRight: '-30px',
//                     }}
//                   >
//                     <input
//                       type="text"
//                       placeholder="Search Here "
//                       style={{
//                         border: "none",
//                         outline: "none",
//                         padding: "5px 10px",
//                         width: "80%",
//                         marginLeft: '10px',
//                       }}
//                       value={searchQuery} // Bind input value
//                       onChange={handleInputChange} // Update state on input change
//                     />
//                     <button
//                       // onClick={handleSearch} // Call handleSearch on click
//                       style={{
//                         backgroundColor: "#000",
//                         color: "white",
//                         border: "none",
//                         padding: "8px 9px",
//                         borderRadius: "10px",
//                         cursor: "pointer",
//                         marginLeft: "50px", // Adjust margin coding
//                       }}
//                     >
//                       <i className="fas fa-search"></i>
//                     </button>
//                   </div>

//                   {/* Suggestions Dropdown */}
//                   {filteredSuggestions.length > 0 && (
//                     <ul
//                       style={{
//                         listStyle: "none",
//                         padding: "10px",
//                         margin: "5px 0",
//                         border: "1px solid #ddd",
//                         borderRadius: "5px",
//                         backgroundColor: "#fff",
//                         position: "absolute",
//                         zIndex: 1000,
//                       }}
//                     >
//                       {filteredSuggestions.map((suggestion, index) => (
//                         <li
//                           key={index}
//                           style={{
//                             padding: "5px 10px",
//                             cursor: "pointer",
//                           }}
//                           onClick={() => handleSuggestionClick(suggestion)} // Handle suggestion click
//                         >
//                           {suggestion.label}
//                         </li>
//                       ))}
//                     </ul>
//                   )}
//                 </div>

//                 {/* Navigation Links */}
//                 <ul
//                   style={{
//                     display: "flex",
//                     listStyle: "none",
//                     margin: "0",
//                     padding: "24",
//                     flex: "1", // Allow navigation to grow and fill available space
//                     justifyContent: "center", // Center navigation links
//                   }}
//                 >
//                   {/* <li>
//                     <Link
//                       to="/"
//                       className={`nav-link ${location.pathname === '/' ? 'active-link' : ''}`}
//                       style={{ margin: "0 10px", fontWeight: 'bold' }}
//                     >
//                      TECHNO TALKS
//                     </Link>
//                   </li> */}
//                   {/* <li>
//                     <Link
//                       to="/who-we-are"
//                       className={`nav-link ${location.pathname === '/who-we-are' ? 'active-link' : ''}`}
//                       style={{ margin: "0 0px", fontWeight: 'bold' }}
//                     >
//                       ABOUT US
//                     </Link>
//                   </li> */}
//                   {/* <li>
//                     <Link
//                       to="/what-we-do"
//                       className={`nav-link ${location.pathname === '/what-we-do' ? 'active-link' : ''}`}
//                       style={{ margin: "0 10px", fontWeight: 'bold' }}
//                     >
//                       PROGRAMS
//                     </Link>
//                   </li> */}
//                   {/* 777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}





//                   <Link
//                       to="/"
//                       className={`nav-link ${location.pathname === '/' ? 'active-link' : ''}`}
//                       style={{ margin: "0 10px", fontWeight: 'bold' }}
//                     >
//                    PROGRAMS
//                     </Link>
//                   <li>
//                     <Link
//                       to="/contact"
//                       className={`nav-link ${location.pathname === '/contact' ? 'active-link' : ''}`}
//                       style={{ margin: "0 10px", fontWeight: 'bold' }}
//                     >
//                   CONTACT US
//                     </Link>
//                   </li>


//                   {/* <a
//   href="/SpeakerPage"
//   target="_blank"
//   rel="noopener noreferrer"
//   className="nav-link"
//   style={{ margin: "0 10px", fontWeight: 'bold' }}
// >
//   TRAINERS
// </a> */}




// <li>
//                   <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//   {/* Existing "SPEAKERS" Link */}
//   {/* <a
//   href="/contact"
//   target="_blank"
//   rel="noopener noreferrer"
//   className="nav-link"
//   style={{ margin: "0 10px", fontWeight: 'bold' }}
// >
//  SPEAKERS
// </a> */}
//   {/* Language Dropdown */}
//   {/* <select
//     style={{
//       border: "1px solid #ccc",
//       borderRadius: "5px",
//       padding: "5px 10px",
//       cursor: "pointer",
//       backgroundColor: "#f7f7f7",
//       fontWeight: "bold",
//     }}
//     onChange={(e) => {
//       console.log("Selected Language:", e.target.value);
//       // Add your logic here for changing the language
//     }}
//   >
//     <option value="en">English</option>
//     <option value="hi">Hindi</option>
//     <option value="fr">French</option>
//     <option value="es">Spanish</option>
//   </select> */}
// </div>

//                   </li>
//                   {/* <div
//                     className="social-icons"
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "25px",

//                     }}
//                   >




//                     {isLoggedIn ? (
//                       <>
//                         <Link to="/shoppingcart" target="_blank">
//                           <span className="ti-shopping-cart" style={{ fontSize: "22px" }}></span>
//                         </Link>



//                         <Link to="https://www.youtube.com/@IIAUTOMATE" target="_blank">
//                           <span className="fa fa-heart" style={{ fontSize: "20px" }}></span>
//                         </Link>

//                         <Link to="https://www.youtube.com/@IIAUTOMATE" target="_blank">
//                           <span className="fa fa-bell" style={{ fontSize: "20px" }}></span>
//                         </Link>

//                         <div style={{ display: "inline-block", position: "relative" }}>
//                           <i
//                             className="fa fa-user-circle"
//                             style={{ fontSize: "22px", cursor: "pointer", color: "#fb9100", marginRight: '28px' }}
//                             onClick={toggleDropdown} // Toggle dropdown when clicked
//                           ></i>
//                           {showDropdown && (
//                             <div
//                               style={{
//                                 position: "absolute",
//                                 top: "30px",
//                                 right: "0",
//                                 backgroundColor: "white",
//                                 border: "1px solid whites",
//                                 borderRadius: "5px",
//                                 padding: "10px",
//                                 boxShadow: "0px 4px 8px rgba(255, 255, 255, 0.1)",
//                                 zIndex: "10",
//                               }}
//                             >
//                               <button
//                                 onClick={handleLogout}
//                                 style={{
//                                   display: "block",
//                                   padding: "5px 10px",
//                                   color: "#fb9100",
//                                   fontSize: "12px",
//                                   border: "none",
//                                   background: "none",
//                                   textDecoration: "none",
//                                   cursor: "pointer",
//                                   whiteSpace: "nowrap",  // Prevents wrapping to a new line
//                                 }}
//                               >
//                                 Log Out
//                               </button>
//                             </div>
//                           )}

//                         </div>

//                       </>
//                     ) : (
//                       // If not logged in, show the Login button
//                       <Link
//                         to="/logindashboard"
//                         className={`nav-link ${location.pathname === '/logindashboard' ? 'active-link' : ''}`}

//                         style={{
//                           margin: "0 10px",
//                           fontWeight: "bold",
//                           padding: "5px 7px",
//                           border: "1px solid #fff",
//                           borderRadius: "5px",
//                           color: "white",
//                           textDecoration: "none",
//                         }}
//                       >
//                         Log in
//                       </Link>


//                     )}




//                   </div> */}

//                   <div style={{ backgroundColor: 'black' }} />




//                   {/* <Link
//   to="/https://dashboard.iiautomate.com"
//   onClick={(e) => {
//     e.preventDefault(); // Prevent default link behavior
//     window.open('https://dashboard.iiautomate.com/', '_blank');
//   }}
//   className={`nav-link ${location.pathname === '/dashboard.iiautomate.com' ? 'active-link' : ''}`}
//   style={{
//     margin: "0 10px",
//     fontWeight: "bold",
//     padding: "5px 7px",
//     border: "1px solid #fff",
//                 borderRadius: "5px",
//                         color: "#fb9100",
//                         textDecoration: "none",
//                         }}
//                          >
//                      Sign up
//                      </Link> */}
//                 </ul>

//                 {/* Social Media Links */}


//               </div>



//               {/* Sidebar Toggle Button for Large Screens */}
//               <div
//                 className="menu-right centered d-none d-md-block"
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",

//                 }}
//                >
//                 {isLoggedIn && (
//                   <Link to="/shoppingcart" target="_blank" className="shoppingcartmobileview">
//                     <span className="ti-shopping-cart" style={{ fontSize: "22px" }}></span>
//                   </Link>
//                 )}
//                 <ul
//                   className="iconright"
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     listStyle: "none", // Remove default list styling
//                     margin: 0,
//                     padding: 0,
//                   }}
//                 >
//                   <li>
//                     <div onClick={toggleSidebar} className="toggle-button" style={{ cursor: "pointer" }}>
//                       <span className="ti-menu"></span>
//                     </div>
//                   </li>
//                 </ul>
//               </div>

//             </div>
//           </div>
//         </div>
//       </header>

//       {/* Sidebar for Large Screens */}
//       {/* Sidebar for Large Screens */}
//       <div className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
//         <div className="sidebar-content">
//           <div
//             className="search-bar"
//             style={{
//               display: "flex",
//               alignItems: "center",
//               border: "1px solid #ddd",
//               borderRadius: "30px",
//               padding: "5px 15px",
//               position: "relative",
//               backgroundColor: "white",
//               // maxWidth: "27%",
//               width: "80%",
//               marginTop: '20px',

//             }}
//           >
//             <input
//               type="text"
//               placeholder="Search What You Want"
//               style={{
//                 border: "none",
//                 outline: "none",
//                 padding: "5px 10px",
//                 width: "80%",
//                 marginLeft: '20px'
//               }}
//               value={searchQuery} // Bind input value
//               onChange={handleInputChange} // Update state on input change
//             />
//             {/* <button
//               onClick={handleSearch} 
//               style={{
//                 backgroundColor: "#000",
//                 color: "white",
//                 border: "none",
//                 padding: "8px 15px",
//                 borderRadius: "10px",
//                 cursor: "pointer",
//                 marginLeft: "10px", // Adjust margin
//               }}
//             >
//               <i className="fas fa-search"></i>
//             </button> */}
//           </div>
//           <ul >
//             <li style={{marginLeft:'-20px',}}>
//               <Link
//                 to="/"
//                 onClick={() => setIsSidebarOpen(false)} // Close sidebar on link click
//                 className={`nav-link ${location.pathname === '/' ? 'active-link' : ''}`}
//               >
//                 HOME
//               </Link>
//             </li>

//             {isLoggedIn ? (
//               <>
//                 <div
//                   className="social-icons"
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "38px", // Space between icons
//                     marginLeft: '35px',
//                   }}
//                 >
//                   {/* <Link to="/shoppingcart" target="_blank">
//                     <span className="ti-shopping-cart" style={{ fontSize: "22px", }}></span>
//                   </Link> */}



//                   {/* <Link to="https://youtube.com/@iiautomate?si=IrKFCc6bIKv8CSEz" target="_blank">
//                     <span className="fa fa-heart" style={{ fontSize: "20px" }}></span>
//                   </Link> */}

//                   <Link to="https://www.youtube.com/@IIAUTOMATE" target="_blank">
//                     <span className="fa fa-bell" style={{ fontSize: "20px", }}></span>
//                   </Link>

//                   <div style={{ display: "inline-block", position: "relative" }}>
//                     <i
//                       className="fa fa-user-circle"
//                       style={{ fontSize: "22px", cursor: "pointer", color: "#fb9100", }}
//                       onClick={toggleDropdown} // Toggle dropdown when clicked
//                     ></i>
//                     {showDropdown && (
//                       <div
//                         style={{
//                           position: "absolute",
//                           top: "30px",
//                           right: "0",
//                           backgroundColor: "#fff",
//                           border: "1px solid #fff",
//                           borderRadius: "5px",
//                           padding: "10px",
//                           boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
//                           zIndex: "10",
//                         }}
//                       >
//                         <button
//                           onClick={handleLogout}
//                           style={{
//                             display: "block",
//                             padding: "5px 10px",
//                             color: "#fb9100",
//                             fontSize: "12px",
//                             border: "none",
//                             background: "none",
//                             textDecoration: "none",
//                             cursor: "pointer",
//                             whiteSpace: "nowrap",  // Prevents wrapping to a new line
//                           }}
//                         >
//                           Log Out
//                         </button>
//                       </div>
//                     )}

//                   </div>
//                 </div>
//               </>
//             ) : (
//               // If not logged in, show the Login button
//               <Link
//               onClick={() => setIsSidebarOpen(false)} 
//                 to="/logindashboard"
//                 className={`nav-link ${location.pathname === '/logindashboard' ? 'active-link' : ''}`}

//                 style={{
//                   margin: "0 10px",
//                   fontWeight: "bold",
//                   padding: "5px 7px",
//                   border: "1px solid #fff",
//                   borderRadius: "5px",
//                   color: "#fff",
//                   textDecoration: "none",
//                 }}
//               >
//                 Log in
//               </Link>
//             )}



//             {/* <li>
//               <Link
//                 to="/registration-form"
//                 onClick={() => setIsSidebarOpen(false)} // Close sidebar on link click 
//                 className={`nav-link ${location.pathname === '/contact' ? 'active-link' : ''}`}
//               >
//                 SIGN UP
//               </Link>
//             </li> */}
//             < br />< br />
//           </ul>
//           <div
//             className="social-icons"
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: "38px", // Space between icons
//               marginLeft: '35px',
//             }}
//           >
//             <Link to="https://x.com/applications_it" target="_blank" style={{ color: '#fff' }}>
//               <span className="ti-twitter" style={{ fontSize: "20px" }}></span>
//             </Link>
//             <Link
//               to="https://www.linkedin.com/company/international-institute-of-automate-iiaofficial/?viewAsMember=true"
//               target="_blank"
//               rel="noopener noreferrer"
//               style={{ color: '#fff' }}

//             >
//               <span className="ti-linkedin" style={{ fontSize: "20px" }}></span>
//             </Link>
//             <Link to="https://www.instagram.com/info.iiautomate/" target="_blank" style={{ color: '#fff' }}>
//               <span className="ti-instagram" style={{ fontSize: "20px" }}></span>
//             </Link>
//             <Link to="https://www.youtube.com/channel/UCCJNxlzUbZKoikghstUhO_A" target="_blank" style={{ color: '#fff' }}>
//               <span className="ti-youtube" style={{ fontSize: "20px" }}></span>
//             </Link>
//             <Link to="https://www.facebook.com/share/1Yig2YL7af/" target="_blank" style={{ color: '#fff' }}>
//               <span className="ti-facebook" style={{ fontSize: "20px" }}></span>
//             </Link>
//           </div>
//         </div>
//       </div>

//       {/* Sidebar and Active Link CSS */}
//       <style jsx>{`
//          .sidebar {
//           position: fixed;
//           top: 0;
//           right: -250px; /* Start off-screen */
//           width: 250px;
//           height: 100%;
//           background-color: #313840;
//           transition: right 0.3s ease-in-out; /* Smooth transition */
//           z-index: 1000; /* Ensure it stays on top */
//         }

//         .sidebar.open {
//           right: 0; /* Slide in */
//           width:100%;
//         }

//         .sidebar-content ul {
//           padding: 0;
//           list-style: none;
//           margin: 0;
//         }

//         .sidebar-content ul li {
//           padding: 15px 20px;
//           border-bottom: 1px solid #444;
//         }

//         .sidebar-content ul li a {
//           color: white;
//           text-decoration: none;
//         }

//         .toggle-button {
//           cursor: pointer;
//         }

//         .dropdown-toggle {
//           background: none;
//           border: none;
//           color: white;
//           padding: 10px;
//           cursor: pointer;
//           width: 100%;
//           text-align: left;
//         }

//         .dropdown-menu {
//           list-style: none;
//           padding: 0;
//           margin: 0;
//           background-color: #444;
//         }

//         // .dropdown-menu li {
//         //   padding: 10px 20px;
//         // }

//         .dropdown-menu li a {
//           color: white;
//           text-decoration: none;
//         }

//         .dropdown-menu li a:hover {
//           color: #f76046;
//         }

//         .active-link {
//           font-weight: bold;
//           // color: #f76046;
//         }

//         /* Show toggle button and sidebar on larger screens */
//         @media (min-width: 1200px) {
//           .sidebar {
//             display: none; /* Hide sidebar */
//           }

//           .toggle-button {
//             display: block; /* Show toggle button */
//           }

//           /* Dropdown for mobile */
//           .dropdown-toggle {
//             display: none; /* Hide dropdown button on larger screens */
//           }
//         }

//         /* For smaller screens (mobile view) */
//         @media (max-width: 767px) {
//           .sidebar-content ul li {
//             padding: 10px 20px;
//           }

//           .dropdown-menu {
//             display: block;
//             background-color: #313840;
//             border-top: 1px solid #313840;
//           }

//           .dropdown-menu li a {
//             padding-left: 40px; /* Indent dropdown items */
//           }

//           .sidebar-content ul li .dropdown-menu li {
//             padding: 10px;
//           }
//         }
//       `}</style>
//     </>
//   );
// };

// export default Nav;







// import React from "react";
// import { FaSearch, FaBars } from "react-icons/fa";
// import logo from "../img/aaaservices/IIA_LOGO_White_v3.png"; // Replace with your actual logo path

// const CustomNavbar = () => {
//   return (
//     <nav
//       style={{
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "space-between",
//         padding: "10px 20px",
//         backgroundColor: "#fff",
//         boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
//         flexWrap: "wrap",
//       }}
//     >
//       {/* Logo */}
//       <div style={{ display: "flex", alignItems: "center" }}>
//         <img src={logo} alt="Logo" style={{ height: "30px" }} />
//       </div>

//       {/* Search Bar */}
//       <div
//         className="search-bar"
//         style={{
//           flexGrow: 1,
//           margin: "10px 20px",
//           display: "flex",
//           alignItems: "center",
//           position: "relative",
//           maxWidth: "600px",
//           flexBasis: "100%",
//         }}
//       >
//         <FaSearch style={{ position: "absolute", left: "10px", color: "#999" }} />
//         <input
//           type="text"
//           placeholder="Search for Movies, Events, Plays, Sports and Activities"
//           style={{
//             width: "100%",
//             padding: "8px 12px 8px 35px",
//             borderRadius: "6px",
//             border: "1px solid #ccc",
//             outline: "none",
//           }}
//         />
//       </div>

//       {/* Right Side */}
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           gap: "10px",
//         }}
//       >
//         {/* City */}
//         <select
//           style={{
//             padding: "6px 10px",
//             borderRadius: "5px",
//             border: "1px solid #ccc",
//             backgroundColor: "#f8f8f8",
//           }}
//         >
//           <option>Hyderabad</option>
//           <option>Delhi</option>
//           <option>Mumbai</option>
//           <option>Bangalore</option>
//         </select>

//         {/* Sign In */}
//         <button
//           style={{
//             backgroundColor: "#f84464",
//             color: "white",
//             border: "none",
//             borderRadius: "5px",
//             padding: "6px 14px",
//             cursor: "pointer",
//           }}
//         >
//           Sign in
//         </button>

//         {/* Hamburger Icon */}
//         <div className="menu-icon" style={{ display: "none" }}>
//           <FaBars size={24} />
//         </div>
//       </div>

//       {/* Responsive Styling */}
//       <style>
//         {`
//           @media (max-width: 768px) {
//             .search-bar {
//               display: none;
//             }
//             .menu-icon {
//               display: block !important;
//             }
//           }
//         `}
//       </style>
//     </nav>
//   );
// };

// export default CustomNavbar;



// import React, { useEffect } from "react";
// import { FaSearch, FaBars } from "react-icons/fa";
// import logo from "../img/aaaservices/LogoIIAHead.png";
// import { Link } from "react-router-dom";
// const CustomNavbar = () => {
//   // Ensure body has top padding equal to navbar height
//   useEffect(() => {
//     document.body.style.paddingTop = "70px"; // adjust if navbar height changes
//     return () => {
//       document.body.style.paddingTop = "0";
//     };
//   }, []);

//   return (
//     <nav
//       style={{
//         position: "fixed",
//         top: 0,
//         left: 0,
//         width: "100%",
//         zIndex: 1000,
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "space-between",
//         padding: "10px 20px",
//         backgroundColor: "#fff",
//         boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
//         flexWrap: "wrap",
//       }}
//     >
//       {/* Logo and Title */}
//       <Link to="/" style={{ textDecoration: "none" }}>
//   <div style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
//     <img src={logo} alt="Logo" style={{ height: "63px", marginRight: "10px" }} />
//     <span
//       style={{
//         fontWeight: "bold",
//         color: "orange",
//         fontSize: "20px",
//         whiteSpace: "nowrap",
//       }}
//     >
//       International Institute <span style={{ color: "blue" }}>of Automate</span>
//     </span>
//   </div>
// </Link>

//       {/* Search Bar */}
//       <div
//         className="search-bar"
//         style={{
//           flexGrow: 1,
//           margin: "10px 20px",
//           display: "flex",
//           alignItems: "center",
//           position: "relative",
//           maxWidth: "600px",
//           flexBasis: "100%",
//         }}
//       >
//         <FaSearch style={{ position: "absolute", left: "10px", color: "#999" }} />
//         <input
//           type="text"
//           placeholder="Search for Movies, Events, Plays, Sports and Activities"
//           style={{
//             width: "100%",
//             padding: "8px 12px 8px 35px",
//             borderRadius: "6px",
//             border: "1px solid #ccc",
//             outline: "none",
//           }}
//         />
//       </div>

//       {/* Right Side */}
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           gap: "10px",
//         }}
//       >
//         {/* City Dropdown */}
//         <select
//           style={{
//             padding: "6px 10px",
//             borderRadius: "5px",
//             border: "1px solid #ccc",
//             backgroundColor: "#f8f8f8",
//           }}
//         >
//           <option>Hyderabad</option>
//           <option>Delhi</option>
//           <option>Mumbai</option>
//           <option>Bangalore</option>
//         </select>

//         {/* Sign In Button */}
//         <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//   {/* <button
//     style={{
//       backgroundColor: "#f84464",
//       color: "white",
//       border: "none",
//       borderRadius: "5px",
//       padding: "6px 14px",
//       cursor: "pointer",
//     }}
//   >
//     Sign in
//   </button> */}

//   {/* Social Media Icons */}
//   <div style={{ display: "flex", gap: "8px" ,fontSize:'20px' }}>
//     <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" style={{ color: "#3b5998" }}>
//       <i className="fab fa-facebook-f"></i>
//     </a>
//     <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" style={{ color: "#0077b5" }}>
//       <i className="fab fa-linkedin-in"></i>
//     </a>
//     <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" style={{ color: "#E1306C" }}>
//       <i className="fab fa-instagram"></i>
//     </a>
//     <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" style={{ color: "#FF0000" }}>
//       <i className="fab fa-youtube"></i>
//     </a>
//   </div>
// </div>

//         {/* Hamburger Menu */}
//         <div className="menu-icon" style={{ display: "none" }}>
//           <FaBars size={24} />
//         </div>
//       </div>

//       {/* Responsive Styling */}
//       <style>
//         {`
//           @media (max-width: 768px) {
//             .search-bar {
//               display: none;
//             }
//             .menu-icon {
//               display: block !important;
//             }
//           }
//         `}
//       </style>
//     </nav>
//   );
// };

// export default CustomNavbar;




// import React, { useEffect, useState } from "react";
// import { FaSearch, FaBars } from "react-icons/fa";
// import logo from "../img/aaaservices/LogoIIAHead.png";
// import { Link } from "react-router-dom";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min";

// const CustomNavbar = () => {
//   useEffect(() => {
//     document.body.style.paddingTop = "70px";
//     return () => {
//       document.body.style.paddingTop = "0";
//     };
//   }, []);

//   return (
//     <nav
//       className="navbar navbar-expand-lg navbar-light bg-white fixed-top shadow-sm px-3"
//       style={{ zIndex: 1000 }}
//     >
//       {/* Logo Section */}
//       <Link to="/" className="navbar-brand d-flex align-items-center">
//         <img src={logo} alt="Logo" height="60" className="me-2" />
//         <span className="text-logo" style={{ fontWeight: "bold", color: "orange", fontSize: "18px" }}>
//           International Institute <span style={{ color: "blue" }}>of Automate</span>
//         </span>
//       </Link>

//       {/* Hamburger Toggle */}
//       <button
//         className="navbar-toggler"
//         type="button"
//         data-bs-toggle="collapse"
//         data-bs-target="#navbarContent"
//         aria-controls="navbarContent"
//         aria-expanded="false"
//         aria-label="Toggle navigation"
//       >
//         <FaBars />
//       </button>

//       {/* Collapsible Content */}
//       <div className="collapse navbar-collapse mt-2 mt-lg-0" id="navbarContent">
//         <ul className="navbar-nav ms-auto w-100 d-flex flex-column flex-lg-row align-items-start align-items-lg-center">
//           {/* Search Bar */}
//           <li className="nav-item w-100 mb-2 mb-lg-0 me-lg-3">
//             <div className="position-relative w-100">
//               <FaSearch
//                 style={{
//                   position: "absolute",
//                   top: "50%",
//                   left: "10px",
//                   transform: "translateY(-50%)",
//                   color: "#999",
//                 }}
//               />
//               <input
//                 type="text"
//                 className="form-control ps-5"
//                 placeholder="Search for Movies, Events, Plays, Sports and Activities"
//               />
//             </div>
//           </li>

//           {/* City Dropdown */}
//           <li className="nav-item mb-2 mb-lg-0 me-lg-3">
//             <select className="form-select">
//               <option>Hyderabad</option>
//               <option>Delhi</option>
//               <option>Mumbai</option>
//               <option>Bangalore</option>
//             </select>
//           </li>

//           {/* Social Icons */}
//           <li className="nav-item">
//             <div className="d-flex gap-3 fs-5">
//               <a
//                 href="https://facebook.com"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 style={{ color: "#3b5998" }}
//               >
//                 <i className="fab fa-facebook-f"></i>
//               </a>
//               <a
//                 href="https://linkedin.com"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 style={{ color: "#0077b5" }}
//               >
//                 <i className="fab fa-linkedin-in"></i>
//               </a>
//               <a
//                 href="https://instagram.com"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 style={{ color: "#E1306C" }}
//               >
//                 <i className="fab fa-instagram"></i>
//               </a>
//               <a
//                 href="https://youtube.com"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 style={{ color: "#FF0000" }}
//               >
//                 <i className="fab fa-youtube"></i>
//               </a>
//             </div>
//           </li>
//         </ul>
//       </div>

//       {/* Bootstrap Icons CDN (required for social icons to display correctly) */}
//       <link
//         rel="stylesheet"
//         href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"
//         integrity="sha512-dyZt8sI6Mvy3KzvMg+6kJZu3iU2XPOJ+K9vZEv0Zp4bNwKOGD0H4K7MeYQ+6XnKJMGX9ZqZtR2q6UpM0MUPVmA=="
//         crossOrigin="anonymous"
//         referrerPolicy="no-referrer"
//       />
//     </nav>
//   );
// };

// export default CustomNavbar;



// import React, { useEffect, useState } from "react";
// import { FaSearch, FaBars } from "react-icons/fa";
// import logo from "../img/aaaservices/LogoIIAHead.png";
// import { Link } from "react-router-dom";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min";

// const CustomNavbar = () => {
//   const [showNavbar, setShowNavbar] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => {
//       if (window.scrollY > 100) {
//         setShowNavbar(true);
//       } else {
//         setShowNavbar(false);
//       }
//     };

//     window.addEventListener("scroll", handleScroll);

//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//     };
//   }, []);

//   useEffect(() => {
//     document.body.style.paddingTop = "0px";
//     return () => {
//       document.body.style.paddingTop = "0";
//     };
//   }, []);

//   return (
//     <>
//       <nav
//         className={`navbar navbar-expand-lg navbar-light bg-white fixed-top shadow-sm px-3 transition-navbar ${
//           showNavbar ? "navbar-visible" : "navbar-hidden"
//         }`}
//         style={{ zIndex: 1000 }}
//       >
//         {/* Logo Section */}
//         <Link to="/" className="navbar-brand d-flex align-items-center">
//           <img src={logo} alt="Logo" height="60" className="me-2" />
//           <span className="text-logo" style={{ fontWeight: "bold", color: "orange", fontSize: "18px" }}>
//             International Institute <span style={{ color: "blue" }}>of Automate</span>
//           </span>
//         </Link>

//         {/* Hamburger Toggle */}
//         <button
//           className="navbar-toggler"
//           type="button"
//           data-bs-toggle="collapse"
//           data-bs-target="#navbarContent"
//           aria-controls="navbarContent"
//           aria-expanded="false"
//           aria-label="Toggle navigation"
//         >
//           <FaBars />
//         </button>

//         {/* Collapsible Content */}
//         <div className="collapse navbar-collapse mt-2 mt-lg-0" id="navbarContent">
//           <ul className="navbar-nav ms-auto w-100 d-flex flex-column flex-lg-row align-items-start align-items-lg-center">
//             {/* Search Bar */}
//             <li className="nav-item w-100 mb-2 mb-lg-0 me-lg-3">
//               <div className="position-relative w-100">
//                 <FaSearch
//                   style={{
//                     position: "absolute",
//                     top: "50%",
//                     left: "10px",
//                     transform: "translateY(-50%)",
//                     color: "#999",
//                   }}
//                 />
//                 <input
//                   type="text"
//                   className="form-control ps-5"
//                   placeholder="Search Here"
//                 />
//               </div>
//             </li>

//             {/* City Dropdown */}
//             <li className="nav-item mb-2 mb-lg-0 me-lg-3">
//               <select className="form-select">
//                 <option>Hyderabad</option>
//                 <option>Delhi</option>
//                 <option>Mumbai</option>
//                 <option>Bangalore</option>
//               </select>
//             </li>

//             {/* Social Icons */}
//             <li className="nav-item">
//               <div className="d-flex gap-3 fs-5">
//                 <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" style={{ color: "#3b5998" }}>
//                   <i className="fab fa-facebook-f"></i>
//                 </a>
//                 <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" style={{ color: "#0077b5" }}>
//                   <i className="fab fa-linkedin-in"></i>
//                 </a>
//                 <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" style={{ color: "#E1306C" }}>
//                   <i className="fab fa-instagram"></i>
//                 </a>
//                 <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" style={{ color: "#FF0000" }}>
//                   <i className="fab fa-youtube"></i>
//                 </a>
//               </div>
//             </li>
//           </ul>
//         </div>

//         {/* Font Awesome Icons */}
//         <link
//           rel="stylesheet"
//           href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"
//           integrity="sha512-dyZt8sI6Mvy3KzvMg+6kJZu3iU2XPOJ+K9vZEv0Zp4bNwKOGD0H4K7MeYQ+6XnKJMGX9ZqZtR2q6UpM0MUPVmA=="
//           crossOrigin="anonymous"
//           referrerPolicy="no-referrer"
//         />
//       </nav>

//       {/* Custom CSS for smooth transition */}
//       <style>{`
//         .transition-navbar {
//           transform: translateY(-100%);
//           transition: transform 0.2s ease-in-out;
//         }
//         .navbar-visible {
//           transform: translateY(0);
//         }
//         .navbar-hidden {
//           transform: translateY(-100%);
//         }
//       `}</style>
//     </>
//   );
// };

// export default CustomNavbar;




// import React, { useEffect, useState } from "react";
// import { FaSearch, FaBars } from "react-icons/fa";
// import logo from "../img/aaaservices/LogoIIAHead.png";
// import { Link } from "react-router-dom";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min";

// const CustomNavbar = () => {
//   const [showNavbar, setShowNavbar] = useState(true);
//   const [lastScrollY, setLastScrollY] = useState(0);

//   useEffect(() => {
//     const handleScroll = () => {
//       const currentScrollY = window.scrollY;

//       if (currentScrollY > lastScrollY && currentScrollY > 100) {
//         // Scroll down
//         setShowNavbar(false);
//       } else {
//         // Scroll up
//         setShowNavbar(true);
//       }

//       setLastScrollY(currentScrollY);
//     };

//     window.addEventListener("scroll", handleScroll);

//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//     };
//   }, [lastScrollY]);

//   return (
//     <>
//       <nav
//         className={`navbar navbar-expand-lg navbar-light bg-white fixed-top shadow-sm px-3 transition-navbar ${
//           showNavbar ? "navbar-visible" : "navbar-hidden"
//         }`}
//         style={{ zIndex: 1000 }}
//       >
//         {/* Logo Section */}
//         <Link to="/" className="navbar-brand d-flex align-items-center">
//           <img src={logo} alt="Logo" height="60" className="me-2" />
//           <span className="text-logo" style={{ fontWeight: "bold", color: "orange", fontSize: "18px" }}>
//             International Institute <span style={{ color: "blue" }}>of Automate</span>
//           </span>
//         </Link>

//         {/* Hamburger Toggle */}
//         <button
//           className="navbar-toggler"
//           type="button"
//           data-bs-toggle="collapse"
//           data-bs-target="#navbarContent"
//           aria-controls="navbarContent"
//           aria-expanded="false"
//           aria-label="Toggle navigation"
//         >
//           <FaBars />
//         </button>

//         {/* Collapsible Content */}
//         <div className="collapse navbar-collapse mt-2 mt-lg-0" id="navbarContent">
//           <ul className="navbar-nav ms-auto w-100 d-flex flex-column flex-lg-row align-items-start align-items-lg-center">
//             {/* Search Bar */}
//             <li className="nav-item w-100 mb-2 mb-lg-0 me-lg-3">
//               <div className="position-relative w-100">
//                 <FaSearch
//                   style={{
//                     position: "absolute",
//                     top: "50%",
//                     left: "10px",
//                     transform: "translateY(-50%)",
//                     color: "#999",
//                   }}
//                 />
//                 <input
//                   type="text"
//                   className="form-control ps-5"
//                   placeholder="Search for Movies, Events, Plays, Sports and Activities"
//                 />
//               </div>
//             </li>

//             {/* City Dropdown */}
//             <li className="nav-item mb-2 mb-lg-0 me-lg-3">
//               <select className="form-select">
//                 <option>Hyderabad</option>
//                 <option>Delhi</option>
//                 <option>Mumbai</option>
//                 <option>Bangalore</option>
//               </select>
//             </li>

//             {/* Social Icons */}
//             <li className="nav-item">
//               <div className="d-flex gap-3 fs-5">
//                 <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" style={{ color: "#3b5998" }}>
//                   <i className="fab fa-facebook-f"></i>
//                 </a>
//                 <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" style={{ color: "#0077b5" }}>
//                   <i className="fab fa-linkedin-in"></i>
//                 </a>
//                 <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" style={{ color: "#E1306C" }}>
//                   <i className="fab fa-instagram"></i>
//                 </a>
//                 <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" style={{ color: "#FF0000" }}>
//                   <i className="fab fa-youtube"></i>
//                 </a>
//               </div>
//             </li>
//           </ul>
//         </div>

//         {/* Font Awesome Icons */}
//         <link
//           rel="stylesheet"
//           href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"
//           integrity="sha512-dyZt8sI6Mvy3KzvMg+6kJZu3iU2XPOJ+K9vZEv0Zp4bNwKOGD0H4K7MeYQ+6XnKJMGX9ZqZtR2q6UpM0MUPVmA=="
//           crossOrigin="anonymous"
//           referrerPolicy="no-referrer"
//         />
//       </nav>

//       {/* Custom CSS for smooth transition */}
//       <style>{`
//         .transition-navbar {
//           transition: transform 0.3s ease-in-out;
//         }
//         .navbar-visible {
//           transform: translateY(0);
//         }
//         .navbar-hidden {
//           transform: translateY(-100%);
//         }
//       `}</style>
//     </>
//   );
// };

// export default CustomNavbar;









// import React, { useEffect, useState,useRef } from 'react';
// import { FaFacebookF, FaInstagram, FaTwitter, FaYoutube, FaLinkedin } from "react-icons/fa";
// import logo from '../img/aaaservices/LogoIIAHead.png';
// import { Link } from 'react-router-dom';
// import { useNavigate } from 'react-router-dom';
// //  import Dropdown from './Dropdown';


// const NavbarScroll = () => {

//   const [showNavbar, setShowNavbar] = useState(false);
//   const [sidebarOpen, setSidebarOpen] = useState(false);

//   const [isOpen, setIsOpen] = useState(false);
//   const [activeItem, setActiveItem] = useState("Mechanical Engineering"); // or whichever default




//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const [mechanicalOpen, setMechanicalOpen] = useState(false);
//   const [InformationTechnologyOpen, setInformationTechnologyOpen] = useState(false);
//   const [DigitalFacultyOpen, setDigitalFacultyOpen] = useState(false);

//   const handleClick = (targetId) => {
//     document.getElementById(targetId)?.scrollIntoView({ behavior: 'smooth' });
//     setSidebarOpen(false);
//     setDropdownOpen(false);
//     setMechanicalOpen(false);
//     setInformationTechnologyOpen(false);
//     setDigitalFacultyOpen(false);
//   };
//   useEffect(() => {
//     const handleScroll = () => {
//       setShowNavbar(window.scrollY > 50);
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const toggleSidebar = () => {
//     setSidebarOpen(!sidebarOpen);
//   };
//   const navigate = useNavigate();


//   const [showDropdown, setShowDropdown] = useState(false);
// const dropdownRef = useRef(null);

// const toggleDropdown = () => {
//   setShowDropdown((prev) => !prev);
// };

//   return (
//     <>
//       <style>{`
//         .navbar-custom {
//           background: transparent;
//           padding: 12px 20px;
//           transition: all 0.4s ease-in-out;
//           transform: translateY(0);
//           opacity: 1;
//           z-index: 999;
//           width: 100%;
//         }
//         .navbar-custom.show {
//           background: white;

//         }

//         .logoss {
//           font-size: 22px;
//           font-weight: bold;
//           color: #ffbe64;

//           display: flex;
//           align-items: center;
//           margin-left: -31px;
//         }
//         .logo-img {
//           height: 48px;
//           width: auto;
//           margin-right: 8px;
//         }

//         .nav-link-custom {
//           font-weight: bold;

//           font-size: 20px;
//           font-family: Roboto, sans-serif;
//           color: gold;
//           text-decoration: none;
//            transition: color 0.3s ease-in-out;
//         }
//         .navbar-custom.show .nav-link-custom {
//           color: #0e7f9d;
//         }
//         .nav-link-custom:hover {
//           color: #ffbe64 !important;
//         }

//         .nav-links {
//           display: flex;
//           align-items: center;
//           gap: 24px;
//           hover: none !importanat;
//         }

//         .social-icons-nav {
//           display: flex;
//           align-items: center;
//           gap: 12px;
//           margin-top:-12px;
//         }
//         .social-icons-nav a {
//           color: gold;
//           font-size: 24px;
//           transition: color 0.3s ease-in-out;
//         }
//         .navbar-custom.show .social-icons-nav a {
//           color: #0e7f9d;
//         }
//         // .social-icons-nav a:hover {
//         //   color: #ffbe64;
//         // }

//         .hamburger {
//           display: none;
//           flex-direction: column;
//           gap: 4px;
//           cursor: pointer;
//         }
//         .hamburger div {
//           width: 25px;
//           height: 3px;
//           background: #ffbe64;
//         }

//         .sidebar {
//           position: fixed;
//           top: 0;
//           left: ${sidebarOpen ? '0' : '-250px'};
//           width: 250px;
//           height: 100%;
//           background-color: #111;
//           color: white;
//           padding-top: 60px;
//           transition: left 0.3s ease-in-out;
//           z-index: 1000;
//         }

//         .sidebar a {
//           display: block;
//           padding: 13px 12px;
//           text-decoration: none;
//           color: #ffbe64;
//           font-weight: bold;
//           font-size: 18px;
//           font-family: Lato, sans-serif;
//           border-bottom: 1px solid #333;
//         }
//         // .sidebar a:hover {
//         //   background-color: #222;
//         // }

//         .social-icons-sidebar {
//           display: flex;
//           justify-content: center;
//           margin-top: 20px;
//         }
//         .social-icons-sidebar a {
//           color: #ffbe64;
//           font-size: 21px;
//           margin: 0 1px;
//         }
//         .social-icons-sidebar a:hover {
//           color: #00bcd4;
//         }

//         @media screen and (max-width: 991px) {
//           .nav-links,
//           .social-icons-nav {
//             display: none !important;
//           }
//           .hamburger {
//             display: flex;
//           }
//         }
//       `}</style>

//       {/* Sidebar */}


//       {/* Navbar */}
//       <div className={`navbar-custom fixed-top ${showNavbar ? 'show' : ''}`}>
//         <div className="container-fluid">
//           <div className="row align-items-center">

//             {/* Logo */}
//             <div className="col-6 col-md-4 col-lg-3 d-flex align-items-center">
//               <div className="logoss">
//                 <Link to="/" className="navbar-brand d-flex align-items-center">
//          <img src={logo} alt="Logo" height="60" className="me-2" />
//          <span className="text-logo" style={{ fontWeight: "bold", color: "orange", fontSize: "18px" }}> INTERNATIONAL INSTITUTE <span style={{ color: "blue" }}>OF AUTOMATE</span>
//          </span>
//        </Link>
//               </div>
//             </div>

//             {/* Nav + Social + Hamburger */}
//             <div className="col-6 col-md-8 col-lg-9 d-flex justify-content-end align-items-center">
//               <div className="d-none d-lg-flex align-items-center" style={{ gap: '17px' }}>
//                 <div className="nav-links">
//                   <a className="nav-link-custom" href="/gaming">WHO WE ARE</a>

//                   <div className="nav-container" ref={dropdownRef}>
//       <a href="#what-we-do" className="nav-link-custom" onClick={toggleDropdown}>
//         WHAT WE DO
//       </a>

//       {showDropdown && (
//         <div className="dropdown-panel">

//         </div>
//       )}


//       <style>{`
//   .nav-container {
//     position: relative;
//     display: inline-block;
//   }

//   .nav-link-custom {
//     color: gold;


//     text-decoration: none;
//     cursor: pointer;
//     display: inline-block;
//     font-weight: bold;
//     border-radius: 5px;
//     transition: background 0.3s ease;
//   }

//   // .nav-link-custom:hover {
//   //   background: #444;
//   // }

//   .dropdown-panel {
//     position: absolute;
//     top: 50%;
//     left: 50%;
//     transform: translateX(-50%);

//     padding: 30px 40px;
//     border-radius: 10px;
//     width: 700px;
//     max-width: 90vw;
//     z-index: 100;

//     color: white;
//     transition: all 0.3s ease;
//   }

//   .dropdown-panel h3 {
//     margin-top: 0;
//     font-size: 22px;
//     text-align: center;
//   }

//   .dropdown-panel ul {
//     padding: 0;
//     margin: 20px 0 0;
//     // display: flex;
//     justify-content: space-around;
//     flex-wrap: wrap;
//     list-style: none;
//   }

//   .dropdown-panel li {
//     margin: 10px;
//     padding: 12px 20px;
//     background: rgba(255, 255, 255, 0.1);
//     border-radius: 8px;
//     cursor: pointer;
//     transition: background 0.3s ease, transform 0.3s ease;
//   }

//   .dropdown-panel li:hover {
//     background: rgba(255, 255, 255, 0.25);
//     transform: scale(1.05);
//   }
// `}</style>

//     </div>

//                   <a className="nav-link-custom" href="#blogs">BLOGS</a>
//                   <a className="nav-link-custom" href="#contact">CONTACT US</a>
//                 </div>
//                 <div className="social-icons-nav">
//                   <a href="https://www.facebook.com/share/16LaYueGg7/" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
//                   <a href="https://www.instagram.com/maamaashouse" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
//                   <a href="https://x.com/MaamaasHouse" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
//                   <a href="https://youtube.com/@maamaashouse" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
//                   <a href="https://www.linkedin.com/company/104887224/" target="_blank" rel="noopener noreferrer"><FaLinkedin /></a>
//                 </div>
//               </div>
//               {/* Hamburger */}
//               <div className="hamburger ms-3" onClick={toggleSidebar}>
//                 <div></div>
//                 <div></div>
//                 <div></div>
//               </div>
//             </div>

//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default NavbarScroll;






// import React, { useEffect, useState } from "react";
// import { FaSearch, FaBars } from "react-icons/fa";
// import logo from "../img/aaaservices/LogoIIAHead.png";
// import { Link } from "react-router-dom";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min";

// const CustomNavbar = () => {
//   const [showNavbar, setShowNavbar] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => {
//       if (window.scrollY > 100) {
//         setShowNavbar(true);
//       } else {
//         setShowNavbar(false);
//       }
//     };

//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   useEffect(() => {
//     document.body.style.paddingTop = "0px";
//     return () => {
//       document.body.style.paddingTop = "0";
//     };
//   }, []);

//   return (
//     <>
//       <nav
//         className={`navbar navbar-expand-lg fixed-top px-3 transition-navbar ${showNavbar ? "navbar-scrolled" : "navbar-top"
//           }`}
//         style={{ zIndex: 1000 }}
//       >
//         {/* Logo Section */}
//         <Link to="/" className="navbar-brand d-flex align-items-center">
//           <img src={logo} alt="Logo" height="60" className="me-2" />
//           <span
//             className="text-logo"
//             style={{
//               fontWeight: "bold",
//               color: "orange",
//               fontSize: "20px",
//             }}
//           >
//           INTERNATIONAL INSTITUTE <span style={{ color: "blue" }}>OF AUTOMATE</span>
//           </span>
//         </Link>

//         {/* Hamburger Toggle */}
//         <button
//           className="navbar-toggler"
//           type="button"
//           data-bs-toggle="collapse"
//           data-bs-target="#navbarContent"
//           aria-controls="navbarContent"
//           aria-expanded="false"
//           aria-label="Toggle navigation"
//         >
//           <FaBars />
//         </button>

//         {/* Collapsible Content */}
//         <div className="collapse navbar-collapse mt-2 mt-lg-0" id="navbarContent">
//           <ul className="navbar-nav ms-auto w-100 d-flex flex-column flex-lg-row align-items-start align-items-lg-center">
//             {/* Search Bar */}
//             <li className="nav-item w-100 mb-2 mb-lg-0 me-lg-3">
           
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "center",
//                   alignItems: "center",
//                   padding: "20px",
//                 }}
//               >
//                 <div
//                   className="position-relative"
//                   style={{
//                     maxWidth: "421px",
//                     width: "100%",
//                     borderRadius: "40px",
//                   }}
//                 >
//                   <FaSearch
//                     style={{
//                       position: "absolute",
//                       top: "50%",
//                       left: "12px",
//                       transform: "translateY(-50%)",
//                       color: "#999",
//                       fontSize: "14px",
//                       zIndex: 1,
//                     }}
//                   />
//                   <input
//                     type="text"
//                     className="form-control ps-5 search-input"
//                     placeholder="Search Here"
//                     style={{
//                       borderRadius: "30px",
//                       paddingLeft: "40px",
//                       height: "45px",
//                       border: "1px solid #ccc",
//                     }}
//                   />
//                 </div>
//               </div>


//             </li>

//             {/* City Dropdown */}
//             <li className="nav-item mb-2 mb-lg-0 me-lg-3">
//               <select className="form-select">
//                 <option>Hyderabad</option>
//                 <option>Delhi</option>
//                 <option>Mumbai</option>
//                 <option>Bangalore</option>
//               </select>
//             </li>

//             {/* Social Icons */}
//             <li className="nav-item">
//               <div className="d-flex gap-3 fs-5">
//                 <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" style={{ color: "#3b5998" }}>
//                   <i className="fab fa-facebook-f"></i>
//                 </a>
//                 <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" style={{ color: "#0077b5" }}>
//                   <i className="fab fa-linkedin-in"></i>
//                 </a>
//                 <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" style={{ color: "#E1306C" }}>
//                   <i className="fab fa-instagram"></i>
//                 </a>
//                 <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" style={{ color: "#FF0000" }}>
//                   <i className="fab fa-youtube"></i>
//                 </a>
//               </div>
//             </li>
//           </ul>
//         </div>

//         {/* Font Awesome CDN */}
//         <link
//           rel="stylesheet"
//           href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"
//           integrity="sha512-dyZt8sI6Mvy3KzvMg+6kJZu3iU2XPOJ+K9vZEv0Zp4bNwKOGD0H4K7MeYQ+6XnKJMGX9ZqZtR2q6UpM0MUPVmA=="
//           crossOrigin="anonymous"
//           referrerPolicy="no-referrer"
//         />
//       </nav>

//       {/* Custom Styles */}
//       <style>{`
//         .transition-navbar {
//           transition: background-color 0.3s ease, box-shadow 0.3s ease, transform 0.2s ease-in-out;
//           width: 100%;
//         }
//         .navbar-top {
//           background-color: transparent !important;
//           box-shadow: none !important;
//           // backdrop-filter: blur(6px);
//         }
//         .navbar-scrolled {
//           background-color: #ffffff !important;
//           box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1) !important;
//         }
//         .search-input {
//           height: 40px;
//           border-radius: 200px;
//           font-size: 14px;
//         }
//       `}</style>
//     </>
//   );
// };

// export default CustomNavbar;





// import React, { useEffect, useState } from "react";
// import { FaSearch, FaBars } from "react-icons/fa";
// import logo from "../img/aaaservices/LogoIIAHead.png";
// import { Link } from "react-router-dom";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min";

// const CustomNavbar = () => {
//   const [showNavbar, setShowNavbar] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => {
//       setShowNavbar(window.scrollY > 100);
//     };

//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   return (
//     <>
//       <nav
//         className={`navbar navbar-expand-lg fixed-top px-3 transition-navbar ${showNavbar ? "navbar-scrolled" : "navbar-top"}`}
//         style={{ zIndex: 1000 }}
//       >
//         {/* Logo */}
//         <Link to="/" className="navbar-brand d-flex align-items-center">
//       <img src={logo} alt="Logo" height="60" className="me-2" />
//       <span className="text-logo">
//         INTERNATIONAL INSTITUTE{" "}
//         <span className={`text-blue ${scrolled ? "scrolled" : ""}`}>
//           OF AUTOMATE
//         </span>
//       </span>
//     </Link>

//         {/* Toggle Button */}
//         <button
//           className="navbar-toggler"
//           type="button"
//           data-bs-toggle="collapse"
//           data-bs-target="#navbarContent"
//           aria-controls="navbarContent"
//           aria-expanded="false"
//           aria-label="Toggle navigation"
//         >
//           <FaBars />
//         </button>

//         {/* Navbar Content */}
//         <div className="collapse navbar-collapse mt-2 mt-lg-0" id="navbarContent">
//           <ul className="navbar-nav ms-auto w-100 d-flex flex-column flex-lg-row align-items-start align-items-lg-center justify-content-end gap-3">
            
//             {/* Search Bar */}
//             <li className="nav-item w-100 w-lg-auto">
//               <div className="search-wrapper">
//                 {/* <FaSearch className="search-icon" /> */}
//                 <input
//                   type="text"
//                   className="form-control search-input"
//                   placeholder="Search Here"
//                 />
//               </div>
//             </li>

//             {/* City Dropdown */}
//             <li className="nav-item">
//               <select className="form-select city-dropdown">
//                 <option>Hyderabad</option>
//                 <option>Delhi</option>
//                 <option>Mumbai</option>
//                 <option>Bangalore</option>
//               </select>
//             </li>

//             {/* Social Media Icons */}
//             <li className="nav-item">
//               <div className="d-flex gap-2 social-icons">
//                 <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-circle" style={{ backgroundColor: "#3b5998" }}>
//                   <i className="fab fa-facebook-f text-white"></i>
//                 </a>
//                 <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-circle" style={{ backgroundColor: "#0077b5" }}>
//                   <i className="fab fa-linkedin-in text-white"></i>
//                 </a>
//                 <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-circle" style={{ backgroundColor: "#E1306C" }}>
//                   <i className="fab fa-instagram text-white"></i>
//                 </a>
//                 <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="social-circle" style={{ backgroundColor: "#FF0000" }}>
//                   <i className="fab fa-youtube text-white"></i>
//                 </a>
//               </div>
//             </li>
//           </ul>
//         </div>

//         {/* Font Awesome CDN */}
//         <link
//           rel="stylesheet"
//           href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"
//           integrity="sha512-dyZt8sI6Mvy3KzvMg+6kJZu3iU2XPOJ+K9vZEv0Zp4bNwKOGD0H4K7MeYQ+6XnKJMGX9ZqZtR2q6UpM0MUPVmA=="
//           crossOrigin="anonymous"
//           referrerPolicy="no-referrer"
//         />
//       </nav>

//       {/* Internal Styles */}
//       <style>{`
//         .transition-navbar {
//           transition: background-color 0.3s ease, box-shadow 0.3s ease;
//           width: 100%;
//         }
//         .navbar-top {
//           background-color: transparent !important;
//           box-shadow: none !important;
//         }
//         .navbar-scrolled {
//           background-color: #fff !important;
//           box-shadow: 0 2px 5px rgba(0,0,0,0.1) !important;
//         }
//         .text-logo {
//           font-weight: bold;
//           color: orange;
//           font-size: 24px;
//         }
//         .text-blue {
//           color: white;
//         }
          
//         .search-wrapper {
//           position: relative;
//           max-width: 400px;
//           width: 100%;
//         }
//         .search-icon {
//           position: absolute;
//           top: 50%;
//           left: 12px;
//           transform: translateY(-50%);
//           color: #999;
//           font-size: 14px;
//           z-index: 1;
//         }
//         .search-input {
//           padding-left: 35px;
//           border-radius: 30px;
//           height: 40px;
//           font-size: 14px;
//           border: 1px solid #ccc;
//         }
//         .city-dropdown {
//           width: 160px;
//           border-radius: 30px;
//           padding-left: 15px;
//           height: 40px;
//           font-size: 14px;
//           border: 1px solid #ccc;
//         }
//         .social-icons .social-circle {
//           width: 35px;
//           height: 35px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           border-radius: 50%;
//           text-decoration: none;
//         }
//         @media (max-width: 991px) {
//           .navbar-nav {
//             align-items: flex-start !important;
//           }
//           .search-wrapper, .city-dropdown {
//             width: 100%;
//           }
//         }
//       `}</style>
//     </>
//   );
// };

// export default CustomNavbar;




import React, { useEffect, useState } from "react";
import { FaBars } from "react-icons/fa";
import logo from "../img/aaaservices/LogoIIAHead.png";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

const CustomNavbar = () => {
  const [showNavbar, setShowNavbar] = useState(false);
  const [scrolled, setScrolled] = useState(false); // Move outside useEffect

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      setShowNavbar(scrollY > 100);
      setScrolled(scrollY > 100); // Update scrolled state
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <nav
        className={`navbar navbar-expand-lg fixed-top px-3 transition-navbar ${
          showNavbar ? "navbar-scrolled" : "navbar-top"
        }`}
        style={{ zIndex: 1000 }}
      >
        {/* Logo */}
        <Link to="/" className="navbar-brand d-flex align-items-center">
          <img  src={logo} alt="Logo" height="60" className="navlogo" />
          <span className="text-logo">
            INTERNATIONAL INSTITUTE{" "}
            <span className={`text-blue ${scrolled ? "scrolled" : ""}`}>
              OF AUTOMATE
            </span>
          </span>
        </Link>

        {/* Toggle Button */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarContent"
          aria-controls="navbarContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <FaBars />
        </button>

        {/* Navbar Content */}
        <div
          className="collapse navbar-collapse mt-2 mt-lg-0"
          id="navbarContent"
        >
          <ul className="navbar-nav ms-auto w-100 d-flex flex-column flex-lg-row align-items-start align-items-lg-center justify-content-end gap-3">
            {/* Search Bar */}
            <li className="nav-item w-100 w-lg-auto">
              <div className="search-wrapper">
                <input
                  type="text"
                  className="form-control search-input"
                  placeholder="Search Here"
                />
              </div>
            </li>

            {/* City Dropdown */}
            <li className="nav-item" style={{marginRight:'62px'}}>
              <select className="form-select city-dropdown">
                <option>Hyderabad</option>
                <option>Delhi</option>
                <option>Mumbai</option>
                <option>Bangalore</option>
              </select>
            </li>

            {/* Social Media Icons */}
            <li className="nav-item">
              <div className="d-flex gap-2 social-icons">
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-circle"
                  style={{ backgroundColor: "#3b5998" }}
                >
                  <i className="fab fa-facebook-f text-white"></i>
                </a>
                <a
                  href="https://linkedin.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-circle"
                  style={{ backgroundColor: "#0077b5" }}
                >
                  <i className="fab fa-linkedin-in text-white"></i>
                </a>
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-circle"
                  style={{ backgroundColor: "#E1306C" }}
                >
                  <i className="fab fa-instagram text-white"></i>
                </a>
                <a
                  href="https://youtube.com/@iiautomate?si=IrKFCc6bIKv8CSEz"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-circle"
                  style={{ backgroundColor: "#FF0000" }}
                >
                  <i className="fab fa-youtube text-white"></i>
                </a>
              </div>
            </li>
          </ul>
        </div>

        {/* Font Awesome */}
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"
          integrity="sha512-dyZt8sI6Mvy3KzvMg+6kJZu3iU2XPOJ+K9vZEv0Zp4bNwKOGD0H4K7MeYQ+6XnKJMGX9ZqZtR2q6UpM0MUPVmA=="
          crossOrigin="anonymous"
          referrerPolicy="no-referrer"
        />
      </nav>

      {/* Internal CSS */}
      <style>{`
        .transition-navbar {
          transition: background-color 0.3s ease, box-shadow 0.3s ease;
          width: 100%;
        }
        .navbar-top {
          background-color: transparent !important;
          box-shadow: none !important;
        }
        .navbar-scrolled {
          background-color: #fff !important;
          box-shadow: 0 2px 5px rgba(0,0,0,0.1) !important;
        }
        .text-logo {
          font-weight: bold;
          color: orange;
          font-size: 24px;
        }
        .text-blue {
          color: white;
        }
        .text-blue.scrolled {
          color: rgb(0, 21, 255);
        }
        .search-wrapper {
          position: relative;
          max-width: 400px;
          width: 100%;
        }
        .search-icon {
          position: absolute;
          top: 50%;
          left: 12px;
          transform: translateY(-50%);
          color: #999;
          font-size: 14px;
          z-index: 1;
        }
        .search-input {
          padding-left: 35px;
          border-radius: 30px;
          height: 40px;
          font-size: 14px;
          border: 1px solid #ccc;
        }
        .city-dropdown {
          width: 160px;
          border-radius: 30px;
          padding-left: 15px;
          height: 40px;
          font-size: 14px;
          border: 1px solid #ccc;
        }
        .social-icons .social-circle {
          width: 35px;
          height: 35px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          text-decoration: none;
        }
        @media (max-width: 991px) {
          .navbar-nav {
            align-items: flex-start !important;
          }
          .search-wrapper, .city-dropdown {
            width: 100%;
          }
        }
      `}</style>
    </>
  );
};

export default CustomNavbar;


